import { createContext } from "preact";
import { ContentPageServiceInterface } from "../interfaces/content-page.interface";

export const ContentPageServiceContext = createContext<ContentPageServiceInterface | null>(null)